import { toPng } from 'html-to-image';

/** Saves an element (a card or item sheet) as a PNG file, without its close button. */
export async function downloadPng(el: HTMLElement, filename: string) {
  const closeBtn = el.querySelector<HTMLElement>('.card-sheet__close');
  if (closeBtn) closeBtn.style.display = 'none';
  const restoreSymbols = inlineSymbols(el);

  try {
    const dataUrl = await toPng(el, {
      pixelRatio: Math.max(window.devicePixelRatio, 2),
      width: el.offsetWidth,
      height: el.offsetHeight,
    });
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    link.click();
  } finally {
    if (closeBtn) closeBtn.style.display = '';
    restoreSymbols();
  }
}

/**
 * html-to-image can't resolve <use href="#symbol-id"> across the document: copies each symbol's
 * drawing into its SVG for the capture. Returns the function that puts them back.
 */
export function inlineSymbols(el: HTMLElement) {
  type UseRestore = { svgEl: SVGSVGElement; savedHTML: string; savedViewBox: string | null };
  const restores: UseRestore[] = [];
  el.querySelectorAll<SVGUseElement>('use').forEach((useEl) => {
    const href = useEl.getAttribute('href') || useEl.getAttribute('xlink:href') || '';
    if (!href.startsWith('#')) return;
    const symbol = document.querySelector<SVGSymbolElement>(href);
    const svgEl = useEl.closest<SVGSVGElement>('svg');
    if (!symbol || !svgEl) return;
    const savedHTML = svgEl.innerHTML;
    const savedViewBox = svgEl.getAttribute('viewBox');
    restores.push({ svgEl, savedHTML, savedViewBox });
    const vb = symbol.getAttribute('viewBox');
    if (vb) svgEl.setAttribute('viewBox', vb);
    svgEl.innerHTML = symbol.innerHTML;
  });
  return () =>
    restores.forEach(({ svgEl, savedHTML, savedViewBox }) => {
      svgEl.innerHTML = savedHTML;
      if (savedViewBox) svgEl.setAttribute('viewBox', savedViewBox);
      else svgEl.removeAttribute('viewBox');
    });
}
